module.exports = __webpack_public_path__ + "static/media/katie.9ade14ce.jpg";